import { RouteType } from "types/RouteType";

// Import individual routes
import companiesRoute from "./Companies/Companies.Route";
import projectInfoRoute from "./ProjectInfo/ProjectInfo.Route";
import administrationRoute from "./Administration/Administration.Route";
import detailingPipelineRoute from "./DetailingPipeline/DetailingPipeline.Route";
import productionRoute from "./Production/Production.Route";
import loadsRoute from "./Loads/Loads.Route";
import shippingCalendarRoute from "./ShippingCalendar/ShippingCalendar.Route";
import dailyReportRoute from "./DailyReport/DailyReport.Route";

/**
 * Miller-Mize Demo Routes
 *
 * All routes are grouped under "Miller-Mize" in the navigation sidebar.
 *
 * CLEANUP AFTER DEMO:
 * - Delete this file
 * - Delete src/views/millermize/ folder
 * - Delete src/stores/millermize/ folder
 * - Remove import from src/views/routesList.tsx
 * - Remove import from src/appStoresConfig.ts
 */
const millerMizeRoutesList: RouteType[] = [
  companiesRoute,
  projectInfoRoute,
  administrationRoute,
  detailingPipelineRoute,
  productionRoute,
  loadsRoute,
  shippingCalendarRoute,
  dailyReportRoute,
];

export default millerMizeRoutesList;
